<template>
<div>
    <div v-if="loading" class="loading-spin">
        <SpinnerLoader :color="'#3c5d3d'" />
    </div>
    <div v-else :style="{ 'filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', 'background' : data.impairedRegime ? '#ffffff' : '#f2f2f2', 'color' : data.impairedRegime ? '#000000' : '#333333' }" class="outer">
        <directory style="margin-left: 8%" :route="$route"></directory>
        <div v-if="list_articles.length || list_services.length || list_news.length || list_FAQ.length">
            <div v-if="lang === 'ru'" class="search-topic">Найдено {{ list_articles.length + list_services.length + list_news.length + list_FAQ.length }} результатов по запросу “{{ $route.query.text }}.”</div>
            <div v-if="lang === 'kk'" class="search-topic">“{{ $route.query.text }}” сұранысы бойынша {{ list_articles.length + list_services.length + list_news.length + list_FAQ.length }} нәтиже табылды.</div>
            <div v-if="list_articles.length" class="articles flex-col">
                <h3 v-if="lang === 'ru'">Раздел “Статьи”</h3>
                <h3 v-if="lang === 'kk'">"Мақалалар” бөлімі</h3>
                <div v-if="list_articles_included.length" class="cards flex-row">
                    <div v-for="data in list_articles" :key="data.id" @click="$router.push({ name: 'article', params: { id: data.id }, query: { rubric: rubric, sub: sub } })" class="card flex-col">
                        <img :data-src="'https://mhsp.unfpa.org' + list_articles_included.find( item => item.type === 'file--file' && item.id === data.relationships.field_cover_image.data.id ).attributes.uri.url" alt="" class="lazyload">
                        <h5>{{ data.attributes.title }}</h5>
                    </div>
                </div>
            </div>
            <div v-if="list_services.length" class="locations flex-col">
                <h3 v-if="lang === 'ru'" >Раздел “МЦЗ”</h3>
                <h3 v-if="lang === 'kk'" >“Жастар Денсаулық Орталықтары” бөлімі</h3>
                <div class="cards flex-row">
                    <div v-for="service in list_services" :key="service.id" @click="$router.push({ name: 'location' })" class="card flex-col">
                            <h3>{{ service.attributes.field_name }}</h3>
                            <ul>
                                <li>Гинекология</li>
                                <li>Уролог</li>
                                <li>Психолог</li>
                                <li>Гинекология</li>
                                <li>Уролог</li>
                            </ul>
                            <div class="label flex-row">
                                <svg style="margin-top: 4px" width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5 1.65e-05C3.67727 -0.00337064 2.408 0.514851 1.46982 1.44122C0.53232 2.36815 0.00334545 3.62643 0 4.94065C0 7.67068 3.74996 14 5 14C6.25004 14 10 7.67068 10 4.94065C9.99659 3.62646 9.46761 2.36814 8.53018 1.44122C7.59212 0.514851 6.32276 -0.00336515 5 1.65e-05ZM5 6.48512C4.20397 6.48512 3.4864 6.00867 3.18182 5.27819C2.87727 4.54715 3.04545 3.70601 3.60852 3.14718C4.17103 2.58774 5.01761 2.42066 5.7534 2.72323C6.48863 3.02581 6.96817 3.73878 6.96817 4.52966C6.96817 5.60958 6.08692 6.4851 5.00003 6.4851L5 6.48512Z" fill="#4F4F4F"/>
                                </svg>
                                <span>{{ service.attributes.field_address_field_1 }}</span>
                            </div>
                            <div class="label flex-row">
                                <svg style="margin-top: 4px" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.6709 10.4581L11.2316 9.08449C10.4185 8.62181 10.391 8.92544 9.53654 9.87971C9.32982 10.111 8.94394 10.7183 8.48915 10.6026C7.53824 10.3568 5.76045 8.89653 5.18163 8.23143C4.906 7.91334 3.7208 6.39518 3.70702 5.90359C3.67946 5.15174 5.25054 4.77582 4.74062 3.34441L3.6519 0.785236C2.63208 -1.67273 -0.220666 2.26002 0.0136171 4.09626C0.619997 8.62181 8.18597 15.9379 12.4031 13.5233C13.3402 12.9739 14.6081 11.0509 13.6709 10.4581Z" fill="#4F4F4F"/>
                                </svg>

                                <span>{{ service.attributes.field_telephone }}</span>
                            </div>
                            <div class="label flex-row">
                                <svg style="margin-top: 4px" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 0C3.1402 0 0 3.1402 0 7C0 10.8598 3.1402 14 7 14C10.8598 14 14 10.8598 14 7C14 3.1402 10.8598 0 7 0Z" fill="#4F4F4F"/>
                                    <path d="M6.99987 1.3999C6.87107 1.3999 6.76654 1.5042 6.76654 1.63324V6.9999H3.26654C3.13774 6.9999 3.0332 7.1042 3.0332 7.23324C3.0332 7.36227 3.13774 7.46657 3.26654 7.46657H6.99987C7.12867 7.46657 7.2332 7.36227 7.2332 7.23324V1.63324C7.2332 1.5042 7.12867 1.3999 6.99987 1.3999Z" fill="#F2F2F2"/>
                                </svg>
                                <span>{{ service.attributes.field_hours_of_operation }}</span>
                            </div>
                        </div>
                </div>
            </div>
            <div v-if="list_news.length" class="news flex-col">
                <h3 v-if="lang === 'ru'">Раздел “Новости”</h3>
                <h3 v-if="lang === 'kk'">“Жаңалықтар” бөлімі</h3>
                <div v-if="list_news_included.length" class="cards flex-row">
                    <div v-for="news in list_news" :key="news.id" @click="$router.push({ name: 'single-news', params: { id: news.id } })" class="card flex-col">
                        <h5 class="author">{{ list_news_included.find( item => item.id === news.relationships.uid.data.id ).attributes.name }}</h5>
                        <span class="date">{{ formatDateTime( news.attributes.created ) }}</span>
                        <h4 :style="{ 'color' : data.impairedRegime ? '#000000' : '#568357' }" class="name">{{ news.attributes.title }}</h4>
                        <p>{{ news.attributes.field_short_description }}</p>
                    </div>
                </div>
            </div>
            <div class="questions-list flex-col">
                <h3 v-if="lang === 'ru'">Раздел “Вопросы и ответы”</h3>
                <h3 v-if="lang === 'kk'">Сұрақ-жауап” бөлімі</h3>
                <div v-for="data in list_FAQ" :key="data.id" class="question-item">
                    <!-- filter( i => dataFAQ.indexOf(i) < 4 ) -->
                    <div :id="data.id" class="info flex-col">
                        <div class="faq-answer" v-html="data.attributes.field_description.value">

                        </div>
                    </div>
                    <div @click="expandQuestion(data.id)" class="more-info">
                        <svg :id="'icon-' + data.id" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M28.8281 13.8281H16.1719V1.17188C16.1719 0.524648 15.6472 0 15 0C14.3528 0 13.8281 0.524648 13.8281 1.17188V13.8281H1.17188C0.524648 13.8281 0 14.3528 0 15C0 15.6472 0.524648 16.1719 1.17188 16.1719H13.8281V28.8281C13.8281 29.4754 14.3528 30 15 30C15.6472 30 16.1719 29.4754 16.1719 28.8281V16.1719H28.8281C29.4754 16.1719 30 15.6472 30 15C30 14.3528 29.4754 13.8281 28.8281 13.8281Z" fill="#568357"/>
                        </svg>
                    </div>
                    <div class="sep-line"></div>
                </div>
            </div>
        </div>
        <div v-else style="max-height: 400px; overflow: hidden;">
            <div v-if="lang === 'ru'" class="not-found">К сожалению, по вашему запросу ничего не найдено</div>
            <div v-if="lang === 'kk'" class="not-found">Өкінішке орай, сіздің іздеуіңізге ақпарат табылмады</div>
            <img class="not-found-img lazyload" data-src="/media/Group 250.png" alt="">
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import { func, api } from '../../variables.js'

export default {
    props: [ 'data' ],
    data(){
        return {
            list_articles: [],
            list_articles_included: [],
            list_news: [],
            list_news_included: [],
            list_services: [],
            list_FAQ: [],
            lang: 'kk',
            loading: false
        }
    },
    created(){
        if( localStorage.getItem('xyzCustomLang') ){
			this.lang = localStorage.getItem('xyzCustomLang')
			window.lang = this.lang
		}
        this.getArticles()
        this.getNews()
    },
    watch:{
        '$route' () {
            this.getArticles()
        }
    },
    methods: {
        getArticles(){
            this.loading = true
            axios.get( api + '/mhealth/jsonapi/node/srh_content/?filter[field_country.name]=KAZ&filter[langcode]=' + this.lang + '&sort=-created&page[offset]=0&page[limit]=10&filter[title-filter][condition][path]=title&filter[title-filter][condition][operator]=CONTAINS&filter[title-filter][condition][value]=' + this.$route.query.text + '&filter[field_tags.name]=articleKZ&&include=uid,uid.user_picture,field_cover_image,field_tags')
            .then((res) => {
                // console.log(res.data)
                this.list_articles = res.data.data
                this.list_articles_included = res.data.included
                this.getNews()
            })
            .catch((e) => {
                this.loading = false
                console.log('Error in loading news\n' + e)
            })
        },
        getNews(){
            axios.get( api + '/mhealth/jsonapi/node/srh_content/?filter[field_country.name]=KAZ&filter[langcode]=' + this.lang + '&sort=-created&page[offset]=0&page[limit]=10&filter[title-filter][condition][path]=title&filter[title-filter][condition][operator]=CONTAINS&filter[title-filter][condition][value]=' + this.$route.query.text + '&filter[field_tags.name]=newsKZ&&include=uid,uid.user_picture,field_cover_image,field_tags')
            .then((res) => {
                this.list_news = res.data.data
                this.list_news_included = res.data.included
                // console.log(this.list_news)
                this.getServices()
            })
            .catch((e) => {
                this.loading = false
                console.log('Error in loading news\n' + e)
            })
        },
        getServices(){
            axios.get( api + '/mhealth/jsonapi/node/srh_service_provider/?filter[field_country.name]=KAZ&sort=-created&page[offset]=0&page[limit]=10&filter[title-filter][condition][path]=title&filter[title-filter][condition][operator]=CONTAINS&filter[title-filter][condition][value]=' + this.$route.query.text )
            .then((res) => {
                this.list_services = res.data.data
                // console.log(this.list_services)
                this.getFAQ()
            })
            .catch((e) => {
                this.loading = false
                console.log('Error in loading news\n' + e)
            })
        },
        getFAQ(){
            axios.get( api + '/mhealth/jsonapi/node/srh_content/?filter[field_country.name]=KAZ&filter[langcode]=' + this.lang + '&sort=-created&page[offset]=0&page[limit]=10&filter[title-filter][condition][path]=title&filter[title-filter][condition][operator]=CONTAINS&filter[title-filter][condition][value]=' + this.$route.query.text + '&filter[field_tags.name]=qakz')
            .then((res) => {
                this.list_FAQ = res.data.data
                console.log(this.list_FAQ)
                this.loading = false
            })
            .catch((e) => {
                this.loading = false
                console.log('Error in loading news\n' + e)
            })
        },
        formatDateTime: func.formatDateTime,
        expandQuestion(id){
            var q_section = document.getElementById(id)
            var q_icon = document.getElementById('icon-' + id)
            var q = q_section.getElementsByTagName('p')[0]
            q_section.getElementsByClassName('on-click-active').forEach( item => {
                if( item.style.display === 'flex'){
                    item.style.display = 'none'
                } else {
                    item.style.display = 'flex'
                }
            })
            if(q.classList.contains('active')){
                q.classList.remove('active')
            } else {
                q.classList.add('active')
            }
            if(q_icon.classList.contains('rotated')){
                q_icon.classList.remove('rotated')
            } else {
                q_icon.classList.add('rotated')
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    h1, h3, h5, p, span, a, label{
        cursor: default;
        text-decoration: none;
        text-align: left;
        margin: 0;
    }
    .outer{
        padding: 30px 0 94px 0;
        .search-topic{
            margin: 44px 8% 35px 8%;
            text-align: left;
            font-weight: 500;
            font-size: 20px;
            line-height: 45px;
            letter-spacing: 0.04em;
        }
        .articles{
            margin: 0 8% 60px 8%;
            h3{
                font-weight: bold;
                font-size: 24px;
                line-height: 45px;
                letter-spacing: 0.04em;
                color: #568357;
            }
            .cards{
                flex-wrap: wrap;
                .card{
                    cursor: pointer;
                    margin: 30px 5% 0 0;
                    width: 30%;
                    img{
                        object-fit: cover;
                        border-radius: 10px;
                        width: 100%;
                        height: 224px !important;
                    }
                    h5, p{
                        margin: 16px 0 0 0;
                        text-align: left;
                        line-height: 26px;
                        letter-spacing: 0.04em;

                    }
                    h5{
                        font-weight: bold;
                        font-size: 28px;
                    }
                }
                .card:nth-of-type(3n){
                    margin-right: 0;
                }
            }
        }
        .locations{
            margin: 0 8% 60px 8%;
            h3{
                font-weight: bold;
                font-size: 24px;
                line-height: 45px;
                letter-spacing: 0.04em;
                color: #568357;
            }
            .cards{
                flex-wrap: wrap;
                .card{
                    cursor: pointer;
                    width: calc(30% - 40px);
                    margin: 30px 5% 0 0;
                    background: #FFFFFF;
                    box-shadow: 0px 8px 12px rgba(43, 42, 41, 0.05), 0px 10px 26px rgba(43, 42, 41, 0.05);
                    border-radius: 10px;
                    padding: 15px 20px;
                    h3{
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 156.61%;
                        letter-spacing: -0.44px;
                    }
                    ul{
                        margin: 10px 0 6px 0;
                        display: flex;
                        flex-direction: row;
                        padding: 0 0 0 15px;
                        width: calc(100% - 15px);
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: horizontal;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        li{
                            margin-left: 30px;
                            font-weight: 300;
                            font-size: 14px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                            color: #568357;
                        }
                        li:first-of-type{
                            margin-left: 0;
                        }
                    }
                    .label{
                        margin-top: 10px;
                        span{
                            cursor: pointer;
                            margin-left: 14px;
                            font-weight: 300;
                            font-size: 14px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                        }
                    }
                }
                .card:nth-of-type(3n){
                    margin-right: 0;
                }
            }
        }
        .news{
            margin: 0 8% 60px 8%;
            h3{
                font-weight: bold;
                font-size: 24px;
                line-height: 45px;
                letter-spacing: 0.04em;
                color: #568357;
            }
            .cards{
                flex-wrap: wrap;
                .card{
                    cursor: pointer;
                    position: relative;
                    width: calc(30% - 40px);
                    margin: 30px 5% 0 0;
                    padding: 20px;
                    background: #F0DCC4;
                    box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                    border-radius: 10px;
                    .author{
                        cursor: pointer;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                    }
                    .date{
                        cursor: pointer;
                        position: absolute;
                        right: 20px;
                        top: 20px;
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                    }
                    .name{
                        text-align: left;
                        cursor: pointer;
                        margin-top: 30px;
                        font-weight: bold;
                        font-size: 20px;
                        line-height: 30px;
                        letter-spacing: 0.05em;
                        color: #568357;
                    }
                    p{
                        cursor: pointer;
                        margin-top: 10px;
                        font-weight: 500;
                        height: 154px;
                        font-size: 16px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                        display: -webkit-box;
                        -webkit-line-clamp: 6;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
                .card:nth-of-type(3n){
                    margin-right: 0;
                }
                .card:hover{
                    background: #F6F4EB;
                }
            }
        }
        .questions-list{
            margin: 0 8% 60px 8%;
            h3{
                font-weight: bold;
                font-size: 24px;
                line-height: 45px;
                letter-spacing: 0.04em;
                color: #568357;
                margin-bottom: 30px;
            }
            .question-item{
                margin-bottom: 30px;
                position: relative;
                .info{
                    width: calc(100% - 60px);
                    h3{
                        font-weight: 500;
                        font-size: 24px;
                        line-height: 45px;
                        letter-spacing: 0.04em;
                        color: #568357;
                    }
                    p{
                        margin-top: 10px;
                        height: 50px;
                        font-weight: 300;
                        font-size: 18px;
                        line-height: 25px;
                        letter-spacing: 0.03em;
                        // display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .on-click-active{
                        display: none;
                    }
                }
                .more-info{
                    cursor: pointer;
                    position: absolute;
                    right: 0;
                    top: 38px;
                    svg{
                        transition: transform 0.5s;
                    }
                    .rotated{
                        transform: rotate(45deg);
                        transition: transform 0.5s;
                    }
                }
                .sep-line{
                    margin-top: 20px;
                    border: 1px solid #BDBDBD;
                }
            }
        }
        .not-found{
            margin: 0 8%;
            text-align: center;
            font-weight: 500;
            font-size: 20px;
            line-height: 45px;
            /* identical to box height, or 225% */

            letter-spacing: 0.04em;

            /* Gray 1 */

            color: #333333;
        }
        .not-found-img{
            margin: 40px auto 0 auto;
            // overflow: hidden;
            // transform: scale(0.25) translateY(-150%);
        }
    }
    @media only screen and (max-width: 1330px){
        .outer{
            padding: 30px 0 80px 0;
            .search-topic{
                margin: 30px 6% 20px 6%;
                text-align: left;
                font-weight: 500;
                font-size: 20px;
                line-height: 45px;
                letter-spacing: 0.04em;
            }
            .articles{
                margin: 0 6% 40px 6%;
                h3{
                    font-weight: bold;
                    font-size: 24px;
                    line-height: 38px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        margin: 20px 5% 0 0;
                        width: 30%;
                        img{
                            border-radius: 10px;
                        }
                        h5{
                            margin: 16px 0 0 0;
                            text-align: left;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                            font-weight: bold;
                            font-size: 22px;

                        }
                    }
                    .card:nth-of-type(3n){
                        margin-right: 0;
                    }
                }
            }
            .locations{
                margin: 0 6% 40px 6%;
                h3{
                    font-weight: bold;
                    font-size: 24px;
                    line-height: 38px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        width: calc(30% - 40px);
                        margin: 20px 5% 0 0;
                        background: #FFFFFF;
                        box-shadow: 0px 8px 12px rgba(43, 42, 41, 0.05), 0px 10px 26px rgba(43, 42, 41, 0.05);
                        border-radius: 10px;
                        padding: 15px 20px;
                        h3{
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                        }
                        ul{
                            margin: 10px 0 6px 0;
                            display: flex;
                            flex-direction: row;
                            padding: 0 0 0 15px;
                            width: calc(100% - 20px);
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: horizontal;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            li{
                                margin-left: 30px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                                color: #568357;
                            }
                            li:first-of-type{
                                margin-left: 0;
                            }
                        }
                        .label{
                            margin-top: 10px;
                            span{
                                cursor: pointer;
                                margin-left: 14px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                        }
                    }
                    .card:nth-of-type(3n){
                        margin-right: 0;
                    }
                }
            }
            .news{
                margin: 0 6% 40px 6%;
                h3{
                    font-weight: bold;
                    font-size: 24px;
                    line-height: 38px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        position: relative;
                        width: calc(30% - 30px);
                        margin: 20px 5% 0 0;
                        padding: 10px 15px;
                        background: #F0DCC4;
                        box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                        border-radius: 10px;
                        .author{
                            cursor: pointer;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                        }
                        .date{
                            cursor: pointer;
                            position: absolute;
                            right: 15px;
                            top: 10px;
                            font-weight: normal;
                            font-size: 14px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                        }
                        .name{
                            cursor: pointer;
                            margin-top: 30px;
                            font-weight: bold;
                            font-size: 18px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                            color: #568357;
                        }
                        p{
                            cursor: pointer;
                            margin-top: 10px;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                        }
                    }
                    .card:nth-of-type(3n){
                        margin-right: 0;
                    }
                    .card:hover{
                        background: #F6F4EB;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 1024px){
        .outer{
            padding: 30px 0 60px 0;
            .search-topic{
                margin: 30px 6% 20px 6%;
                text-align: left;
                font-weight: 500;
                font-size: 20px;
                line-height: 30px;
                letter-spacing: 0.04em;
            }
            .articles{
                margin: 0 6% 40px 6%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        margin: 20px 4% 0 0;
                        width: 48%;
                        img{
                            border-radius: 10px;
                        }
                        h5{
                            margin: 16px 0 0 0;
                            text-align: left;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                            font-weight: bold;
                            font-size: 22px;

                        }
                    }
                    .card:nth-of-type(3n){
                        margin-right: 4%;
                    }
                    .card:nth-of-type(2n){
                        margin-right: 0;
                    }
                }
            }
            .locations{
                margin: 0 6% 40px 6%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        width: calc(48% - 40px);
                        margin: 20px 4% 0 0;
                        background: #FFFFFF;
                        box-shadow: 0px 8px 12px rgba(43, 42, 41, 0.05), 0px 10px 26px rgba(43, 42, 41, 0.05);
                        border-radius: 10px;
                        padding: 15px 20px;
                        h3{
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                        }
                        ul{
                            margin: 10px 0 6px 0;
                            display: flex;
                            flex-direction: row;
                            padding: 0 0 0 15px;
                            width: calc(100% - 20px);
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: horizontal;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            li{
                                margin-left: 30px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                                color: #568357;
                            }
                            li:first-of-type{
                                margin-left: 0;
                            }
                        }
                        .label{
                            margin-top: 10px;
                            span{
                                cursor: pointer;
                                margin-left: 14px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                        }
                    }
                    .card:nth-of-type(3n){
                        margin-right: 4%;
                    }
                    .card:nth-of-type(2n){
                        margin-right: 0;
                    }
                }
            }
            .news{
                margin: 0 6% 30px 6%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        position: relative;
                        width: calc(48% - 30px);
                        margin: 20px 4% 0 0;
                        padding: 10px 15px;
                        background: #F0DCC4;
                        box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                        border-radius: 10px;
                        .author{
                            cursor: pointer;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                        }
                        .date{
                            cursor: pointer;
                            position: absolute;
                            right: 15px;
                            top: 10px;
                            font-weight: normal;
                            font-size: 14px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                        }
                        .name{
                            cursor: pointer;
                            margin-top: 30px;
                            font-weight: bold;
                            font-size: 18px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                            color: #568357;
                        }
                        p{
                            cursor: pointer;
                            margin-top: 10px;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                        }
                    }
                    .card:nth-of-type(3n){
                        margin-right: 4%;
                    }
                    .card:nth-of-type(2n){
                        margin-right: 0;
                    }
                    .card:hover{
                        background: #F6F4EB;
                    }
                }
            }
            .questions-list{
                margin: 0 6% 30px 6%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                    margin-bottom: 20px;
                }
                .question-item{
                    margin-bottom: 30px;
                    position: relative;
                    .info{
                        width: calc(100% - 60px);
                        h3{
                            font-weight: 500;
                            font-size: 24px;
                            line-height: 45px;
                            letter-spacing: 0.04em;
                            color: #568357;
                        }
                        p{
                            margin-top: 10px;
                            height: 50px;
                            font-weight: 300;
                            font-size: 18px;
                            line-height: 25px;
                            letter-spacing: 0.03em;
                            // display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .on-click-active{
                            display: none;
                        }
                        .feedback-text{
                            margin-top: 10px;
                            font-weight: 500;
                            font-size: 18px;
                            line-height: 25px;
                            letter-spacing: 0.03em;
                            color: #333333;
                        }
                        .feedback-btns{
                            margin-top: 6px;
                            .option{
                                z-index: 99;
                                cursor: pointer;
                                margin-right: 20px;
                                text-align: center;
                                padding: 13px 0;
                                width: 120px;
                                border-radius: 10px;
                                font-weight: 500;
                                font-size: 16px;
                                line-height: 26px;
                                text-align: center;
                                letter-spacing: 0.04em;
                            }
                            .option.yes{
                                border: 2px solid #FFFFFF;
                                background: #568357;
                                color: #FFFFFF;
                            }
                            .option.no{
                                background: #FFFFFF;
                                border: 2px solid #568357;
                                color: #568357;
                            }
                            .icon{
                                margin-left: 16px;
                            }
                            .label{
                                cursor: default;
                                margin-left: 10px;
                                font-weight: 500;
                                font-size: 18px;
                                line-height: 25px;
                                letter-spacing: 0.03em;
                                color: #568357;
                            }
                        }

                    }
                    .more-info{
                        cursor: pointer;
                        position: absolute;
                        right: 0;
                        top: 38px;
                        svg{
                            transition: transform 0.5s;
                        }
                        .rotated{
                            transform: rotate(45deg);
                            transition: transform 0.5s;
                        }
                    }
                    .sep-line{
                        margin-top: 20px;
                        border: 1px solid #BDBDBD;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 720px){
        .outer{
            padding: 30px 0 60px 0;
            .search-topic{
                margin: 20px 6% 10px 6%;
                text-align: left;
                font-weight: 500;
                font-size: 20px;
                line-height: 30px;
                letter-spacing: 0.04em;
            }
            .articles{
                margin: 0 6% 40px 6%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        margin: 20px 0 0 0;
                        width: 100%;
                        img{
                            border-radius: 10px;
                        }
                        h5{
                            margin: 8px 0 0 0;
                            text-align: left;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                            font-weight: bold;
                            font-size: 22px;

                        }
                    }
                    .card:nth-of-type(3n){
                        margin-right: 0;
                    }
                    .card:nth-of-type(2n){
                        margin-right: 0;
                    }
                }
            }
            .locations{
                margin: 0 6% 60px 6%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        width: calc(100% - 28px);
                        margin: 20px 0 0 0;
                        background: #FFFFFF;
                        box-shadow: 0px 8px 12px rgba(43, 42, 41, 0.05), 0px 10px 26px rgba(43, 42, 41, 0.05);
                        border-radius: 10px;
                        padding: 8px 14px;
                        h3{
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                        }
                        ul{
                            margin: 10px 0 6px 0;
                            display: flex;
                            flex-direction: row;
                            padding: 0 0 0 15px;
                            width: calc(100% - 20px);
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: horizontal;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            li{
                                margin-left: 30px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                                color: #568357;
                            }
                            li:first-of-type{
                                margin-left: 0;
                            }
                        }
                        .label{
                            margin-top: 10px;
                            span{
                                cursor: pointer;
                                margin-left: 14px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                        }
                    }
                    .card:nth-of-type(3n){
                        margin-right: 0;
                    }
                    .card:nth-of-type(2n){
                        margin-right: 0;
                    }
                }
            }
            .news{
                margin: 0 6% 30px 6%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        position: relative;
                        width: calc(100%);
                        margin: 20px 0 0 0;
                        padding: 6px 12px;
                        background: #F0DCC4;
                        box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                        border-radius: 10px;
                        .author{
                            cursor: pointer;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                        }
                        .date{
                            cursor: pointer;
                            position: absolute;
                            right: 12px;
                            top: 6px;
                            font-weight: normal;
                            font-size: 14px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                        }
                        .name{
                            cursor: pointer;
                            margin-top: 30px;
                            font-weight: bold;
                            font-size: 18px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                            color: #568357;
                        }
                        p{
                            cursor: pointer;
                            margin-top: 10px;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                        }
                    }
                    .card:nth-of-type(3n){
                        margin-right: 0;
                    }
                    .card:nth-of-type(2n){
                        margin-right: 0;
                    }
                    .card:hover{
                        background: #F6F4EB;
                    }
                }
            }
            .questions-list{
                margin: 0 6% 30px 6%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                    margin-bottom: 20px;
                }
                .question-item{
                    margin-bottom: 15px;
                    position: relative;
                    .info{
                        width: calc(100% - 60px);
                        .on-click-active{
                            display: none;
                        }
                        .feedback-text{
                            margin-top: 10px;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 20px;
                            letter-spacing: 0.03em;
                            color: #333333;
                        }
                        .feedback-btns{
                            margin-top: 6px;
                            .option{
                                z-index: 99;
                                cursor: pointer;
                                margin-right: 20px;
                                text-align: center;
                                padding: 8px 0;
                                width: 120px;
                                border-radius: 10px;
                                font-weight: 500;
                                font-size: 14px;
                                line-height: 20px;
                                text-align: center;
                                letter-spacing: 0.04em;
                            }
                            .option.yes{
                                border: 2px solid #FFFFFF;
                                background: #568357;
                                color: #FFFFFF;
                            }
                            .option.no{
                                background: #FFFFFF;
                                border: 2px solid #568357;
                                color: #568357;
                            }
                            .icon{
                                margin-left: 16px;
                            }
                            .label{
                                cursor: default;
                                margin-left: 10px;
                                font-weight: 500;
                                font-size: 14px;
                                line-height: 25px;
                                letter-spacing: 0.03em;
                                color: #568357;
                            }
                        }

                    }
                    .more-info{
                        cursor: pointer;
                        position: absolute;
                        right: 0;
                        top: 10px;
                        svg{
                            transition: transform 0.5s;
                            transform: scale(0.7);
                        }
                        .rotated{
                            transform: rotate(45deg) scale(0.7);
                            transition: transform 0.5s;
                        }
                    }
                    .sep-line{
                        margin-top: 10px;
                        border: 1px solid #BDBDBD;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 480px){
        .outer{
            padding: 30px 0 60px 0;
            .search-topic{
                margin: 20px 4% 10px 4%;
                text-align: left;
                font-weight: 500;
                font-size: 20px;
                line-height: 24px;
                letter-spacing: 0.04em;
            }
            .articles{
                margin: 0 4% 40px 4%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        margin: 20px 0 0 0;
                        width: 100%;
                        img{
                            border-radius: 10px;
                        }
                        h5{
                            margin: 4px 0 0 0;
                            text-align: left;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                            font-weight: bold;
                            font-size: 18px;

                        }
                    }
                    .card:nth-of-type(3n){
                        margin-right: 0%;
                    }
                    .card:nth-of-type(2n){
                        margin-right: 0;
                    }
                }
            }
            .locations{
                margin: 0 4% 40px 4%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        width: calc(100% - 28px);
                        margin: 20px 0 0 0;
                        background: #FFFFFF;
                        box-shadow: 0px 8px 12px rgba(43, 42, 41, 0.05), 0px 10px 26px rgba(43, 42, 41, 0.05);
                        border-radius: 10px;
                        padding: 8px 14px;
                        h3{
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                        }
                        ul{
                            margin: 10px 0 6px 0;
                            display: flex;
                            flex-direction: row;
                            padding: 0 0 0 15px;
                            width: calc(100% - 20px);
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: horizontal;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            li{
                                margin-left: 30px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                                color: #568357;
                            }
                            li:first-of-type{
                                margin-left: 0;
                            }
                        }
                        .label{
                            margin-top: 10px;
                            span{
                                cursor: pointer;
                                margin-left: 14px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                        }
                    }
      
                }
            }
            .news{
                margin: 0 4% 20px 4%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                .cards{
                    flex-wrap: wrap;
                    .card{
                        cursor: pointer;
                        position: relative;
                        width: calc(100%);
                        margin: 20px 0 0 0;
                        padding: 6px 12px;
                        background: #F0DCC4;
                        box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                        border-radius: 10px;
                        .author{
                            cursor: pointer;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                        }
                        .date{
                            cursor: pointer;
                            position: absolute;
                            right: 12px;
                            top: 6px;
                            font-weight: normal;
                            font-size: 14px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                        }
                        .name{
                            cursor: pointer;
                            margin-top: 30px;
                            font-weight: bold;
                            font-size: 18px;
                            line-height: 30px;
                            letter-spacing: 0.05em;
                            color: #568357;
                        }
                        p{
                            cursor: pointer;
                            margin-top: 10px;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                        }
                    }
                    .card:nth-of-type(3n){
                        margin-right: 0;
                    }
                    .card:nth-of-type(2n){
                        margin-right: 0;
                    }
                    .card:hover{
                        background: #F6F4EB;
                    }
                }
            }
            .questions-list{
                margin: 0 4% 40px 4%;
                h3{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
            }
        }
    }
</style>


